<template>
  <div class="question-dialog">
    <!-- 设置问卷弹窗 -->
    <vh-dialog
      :title="$t('host.k_581001')"
      :visible.sync="settingQuestionShow"
      @close="closeQuestion"
      :modal="false"
      width="500px"
    >
      <div class="question-dialog_wrapper" :class="{ 'read-only': readOnly }">
        <div class="question-left">{{ $t('host.k_581002') }}</div>
        <div class="question-right">
          <div class="question-right_way">
            <vh-radio v-model="condition" @input="changeValue" :label="1">
              {{ $t('host.k_581003') }}
            </vh-radio>
            <br />
            <!-- <vh-radio v-model="condition" :label="2">提交全部问卷</vh-radio> -->
            <vh-radio v-model="condition" :label="3">{{ $t('host.k_581004') }}</vh-radio>
          </div>
          <div class="question-right_appoint" v-if="condition == 3">
            <span @click="selectQuestion">
              <i class="vh-iconfont vh-line-circle-plus-outline"></i>
              {{ $t('host.k_581005') }}
            </span>
          </div>
          <div class="question-right_list" v-if="condition == 3">
            <div
              :class="['list_item', item.error_status == 1 ? 'tags__error' : '']"
              v-for="(item, index) in questionList"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <i class="vh-icon-close" @click="deleteSelectQuestion(item.question_id)"></i>
            </div>
          </div>
          <div class="question-right_error">{{ errorText }}</div>
          <div slot="footer" class="dialog-footer" v-if="!readOnly">
            <vh-button size="medium" type="info" plain @click.prevent.stop="closeQuestion" round>
              {{ $t('host.k_581006') }}
            </vh-button>
            <vh-button size="medium" v-preventReClick type="primary" @click="sureQuestion" round>
              {{ $t('host.k_581007') }}
            </vh-button>
          </div>
        </div>
      </div>
    </vh-dialog>
    <checked-question
      ref="checkedQuestionDialog"
      :questionList="questionList"
      @addQuestion="addQuestionInfo"
    ></checked-question>
  </div>
</template>
<script>
  import checkedQuestion from './checked-question.vue';
  import { useQuestionnaireServer } from 'middle-domain';
  export default {
    data() {
      return {
        settingQuestionShow: false,
        condition: 3,
        total: 0,
        errorText: '',
        lotteryId: '',
        questionList: [],
        checkedQuestionList: []
      };
    },
    props: {
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    components: {
      checkedQuestion
    },
    beforeCreate() {
      this.questionnaireServer = useQuestionnaireServer({
        uploadUrl: process.env.VUE_APP_BASE_URL,
        mode: 'live'
      });
    },
    methods: {
      // 打开选择问卷弹窗
      selectQuestion() {
        this.$refs.checkedQuestionDialog.openCheckDialog();
      },
      openSettingDialog(id, info) {
        this.lotteryId = id || '';
        const questionInfo = JSON.parse(JSON.stringify(info));
        this.condition = questionInfo.type;
        this.questionList = questionInfo.survey_list;
        this.settingQuestionShow = true;
        this.errorText = '';
        this.resetQuestionInfo();
      },
      changeValue() {
        this.errorText = '';
        this.resetQuestionInfo();
      },
      resetQuestionInfo() {
        this.questionList = this.questionList.map(item => {
          item.error_status = 0;
          return item;
        });
      },
      addQuestionInfo(list) {
        this.questionList.push(...list);
        // let id = 'question_id';
        // this.questionList = this.questionList.reduce(
        //   (all, next) => (all.some(atom => atom[id] == next[id]) ? all : [...all, next]),
        //   []
        // );
        console.log(this.questionList, '问卷去重');
      },
      deleteSelectQuestion(id) {
        this.questionList.map((item, index) => {
          if (item.question_id === id) {
            this.questionList.splice(index, 1);
          }
        });
      },
      sureQuestion() {
        const questionInfo = {
          type: this.condition,
          survey_list: []
        };
        if (this.condition != 3) {
          this.$emit('selectQuestion', questionInfo);
          this.settingQuestionShow = false;
          return;
        }
        const checkList = this.questionList.map(item => item.question_id);
        if (!checkList.length) {
          this.$message.error(this.$t('host.k_581008'));
          return;
        }
        this.questionnaireServer
          .checkSelectSurvey({
            survey_ids: checkList.join(',')
          })
          .then(res => {
            if (res.code === 200) {
              const noList = res.data?.non_existent || [];
              if (noList.length) {
                this.settingQuestionShow = true;
                this.errorText = this.$t('host.k_581009');
                this.questionList = this.questionList.map(item => {
                  if (noList.includes(Number(item.question_id))) {
                    item.error_status = 1;
                  }
                  return item;
                });
              } else {
                questionInfo.survey_list = this.questionList;
                this.errorText = '';
                this.$emit('selectQuestion', questionInfo);
                this.settingQuestionShow = false;
              }
            } else {
              this.settingQuestionShow = true;
            }
          })
          .catch(res => {
            this.settingQuestionShow = true;
            this.$message.error(this.$t('host.k_581010'));
          });
      },
      closeQuestion() {
        this.settingQuestionShow = false;
      }
    }
  };
</script>
<style lang="less">
  .question-dialog {
    &.read-only {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 10;
      }
    }
    &_wrapper {
      display: flex;
      width: 100%;
      &.read-only {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.5);
          z-index: 10;
        }
      }
      .question-left {
        width: 70px;
        text-align: left;
        font-weight: 400;
        font-size: 14px;
        line-height: 40px;
        color: #1a1a1a;
      }
      .question-right {
        width: calc(100% - 70px);
        &_appoint {
          margin: 8px 0;
          span {
            display: inline-block;
            background: #fff;
            min-width: 120px;
            padding: 0 8px;
            height: 36px;
            border: 1px solid #d9d9d9;
            border-radius: 50px;
            font-size: 14px;
            color: #262626;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            i {
              vertical-align: bottom;
              color: rgba(0, 0, 0, 0.85);
            }
            &:hover {
              background: #fb3a32;
              color: #fff;
              border: 1px solid transparent;
              i {
                color: #fff;
              }
            }
          }
        }
        &_list {
          max-height: 160px;
          overflow-y: auto;
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin: 12px 0;
          .list_item {
            padding: 3px 12px;
            background: #f0f0f0;
            border-radius: 50px;
            cursor: pointer;
            span {
              display: inline-block;
              max-width: 200px;
              color: #595959;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              vertical-align: middle;
              padding-right: 5px;
              line-height: 20px;
            }
            i {
              font-size: 12px;
              color: #595959;
              cursor: pointer;
            }
            &:hover {
              background: #fff2f0;
              span {
                color: #fb3a32;
              }
              i {
                color: #fb3a32;
              }
            }
            &.tags__error {
              border: 1px solid #fb3a32;
              background: #fff2f0;
              span {
                color: #fb3a32;
              }
              i {
                color: #fb3a32;
              }
            }
          }
        }
        &_error {
          color: #fb3a32;
          font-size: 14px;
          padding-top: 5px;
        }
      }

      .dialog-footer {
        justify-content: right;
      }
    }
  }
</style>
